var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "306px",
    height: "405px",
    viewBox: "0 0 306 405",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "red_marker") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "red_marker",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.486171,284.452531 C264.270966,223.57452 289,172.23994 289,135.999158 C289,61.0094009 227.990599,0 153,0 C78.0094009,0 17,61.0094009 17,136 C17,172.522932 41.7905174,224.012485 88.6915417,284.899761 C114.207228,318.025094 139.910735,345.578161 152.982313,359.075071 C166.091792,345.489726 191.929215,317.707569 217.486171,284.452531 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83,138.5 C83,99.6263831 114.625789,68 153.500383,68 C192.374211,68 224,99.6256168 224,138.5 C224,177.374383 192.374211,209 153.500383,209 C114.626555,209 83,177.374383 83,138.5 Z",
    id: "Path",
    fill: "#D96464",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.999153,139.5 C205.999153,110.551592 182.448408,87 153.5,87 C124.551592,87 101,110.550745 101,139.5 C101,168.449255 124.551592,192 153.5,192 C182.448408,192 205.999153,168.449255 205.999153,139.5 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.398,291.243 C242.770241,286.464428 216.257621,284.214428 216.257621,284.214428 C184.068088,323.737239 160.225054,346.128708 160.225054,350.929 L152.865,357.902913 L144.54887,350.929 C141.72287,348.175 117.727253,321.692832 87.5497903,284.214428 C75.4701821,284.214428 59.348,288.022 50.332,291.243 C8.732,306.109 0,326.075 0,340.206 C0,354.337 8.732,374.303 50.332,389.169 C77.95,399.039 114.364,404.475 152.865,404.475 C191.366,404.475 227.78,399.039 255.398,389.169 C296.997,374.303 305.729,354.337 305.729,340.206 C305.729,326.075 301.679973,308.756933 255.398,291.243 Z",
    id: "Shape",
    fill: "#D96464",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedMarker);
export default __webpack_public_path__ + "static/media/red_marker.fe4f34899c5d3289d57a85e89c66bc6d.svg";
export { ForwardRef as ReactComponent };